module.exports = __webpack_public_path__ + "static/media/susi_forel.028e4236.jpeg";